import { WorkflowConfig } from '../models';

/**
 * The project object that represents the Samelogic Project for the current environment.
 *
 * @remarks
 * This object is usually retrieved from the Samelogic platform using the {@link @samelogic/samelogic-js#Options.appId}.
 * But it can also be passed in to the SDK directly.
 *
 * @internal
 */
export interface Project {
  /**
   * The environment Id of the project.
   */
  envId: string;
  /**
   * The project Id of the project.
   */
  projectId?: string;

  /**
   * The organisation Id of the project.
   */
  orgId?: string;

  /**
   * The list of currently **active** workflows. Worklows must be published to be active.
   */
  workflows: WorkflowConfig[];
}
